import { Buffergs925ekssbch as Buffer } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import { writeFully359t6q8kam2g5 as writeFully } from '../../../../ktor-ktor-io/io/ktor/utils/io/core/BytePacketBuilder.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { readText27783kyxjxi1g as readText } from '../../../../ktor-ktor-io/io/ktor/utils/io/core/Strings.mjs';
import { CloseReason10cphaqpp3ct7 as CloseReason } from './CloseReason.mjs';
import { DisposableHandle1uzxt8frdchxn as DisposableHandle } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Charsets_getInstanceqkyjyusuh1b0 as Charsets_getInstance } from '../../../../ktor-ktor-io/io/ktor/utils/io/charsets/Charset.js.mjs';
import { decode1t43jmuxrxpmo as decode } from '../../../../ktor-ktor-io/io/ktor/utils/io/charsets/Encoding.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readReason(_this__u8e3s4) {
  if (_this__u8e3s4.v5c_1.length < 2) {
    return null;
  }
  // Inline function 'io.ktor.utils.io.core.buildPacket' call
  var builder = new (Buffer())();
  writeFully(builder, _this__u8e3s4.v5c_1);
  var packet = builder;
  var code = packet.y4f();
  var message = readText(packet);
  return CloseReason().k5b(code, message);
}
var NonDisposableHandleClass;
function NonDisposableHandle() {
  if (NonDisposableHandleClass === VOID) {
    class $ {
      uz() {
        return Unit_instance;
      }
      toString() {
        return 'NonDisposableHandle';
      }
      hashCode() {
        return 207988788;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NonDisposableHandle()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'NonDisposableHandle', VOID, VOID, [DisposableHandle()]);
    NonDisposableHandleClass = $;
  }
  return NonDisposableHandleClass;
}
var NonDisposableHandle_instance;
function NonDisposableHandle_getInstance() {
  return NonDisposableHandle_instance;
}
function readText_0(_this__u8e3s4) {
  // Inline function 'kotlin.require' call
  if (!_this__u8e3s4.t5c_1) {
    var message = 'Text could be only extracted from non-fragmented frame';
    throw IllegalArgumentException().n2(toString(message));
  }
  var tmp = Charsets_getInstance().h4m_1.k4m();
  // Inline function 'io.ktor.utils.io.core.buildPacket' call
  var builder = new (Buffer())();
  writeFully(builder, _this__u8e3s4.v5c_1);
  return decode(tmp, builder);
}
//region block: init
NonDisposableHandle_instance = new (NonDisposableHandle())();
//endregion
//region block: exports
export {
  NonDisposableHandle_instance as NonDisposableHandle_instance3amt6bvd9jgby,
  readReason as readReason2qq1b0s02pdpy,
  readText_0 as readText30p9xkeoodw49,
};
//endregion

//# sourceMappingURL=FrameCommon.mjs.map
